/**
 * In-memory cache + in-flight dedupe for rarely changing list payloads (e.g. reference metadata).
 * Not for paginated entity lists that must reflect CRUD immediately.
 */
export function createStaticListCache() {
  let cached = null;
  let inflight = null;

  return {
    /**
     * @template T
     * @param {() => Promise<T>} loader
     * @returns {Promise<T>}
     */
    async getOrLoad(loader) {
      if (cached != null) {
        return cached;
      }
      if (inflight) {
        return inflight;
      }
      inflight = (async () => {
        try {
          const value = await loader();
          cached = value;
          return value;
        } finally {
          inflight = null;
        }
      })();
      return inflight;
    },
    invalidate() {
      cached = null;
    }
  };
}
